import { TextConfigurationTextProperties } from '@/types';
import { parseFloatOrZero } from '@/utils/parseFloatOrZero';
import { isComplexTextContent } from './isComplexTextContent';

export const getTextCoordinates = (text: TextConfigurationTextProperties) => {
  const content = text.content[0];

  if (isComplexTextContent(content)) {
    if ('x' in content) {
      return {
        x: parseFloatOrZero(content.x),
        y: parseFloatOrZero(content.y),
      };
    }
  }

  return {
    x: parseFloatOrZero(text.x),
    y: parseFloatOrZero(text.y),
  };
};
